module.exports = __webpack_public_path__ + "img/indices.d0c9879e.jpeg";